<template>
  <v-card-actions class="d-print-none">
    <v-btn
      text
      v-if="boutonModificationVisible && editable"
      :loading="control.entreeEdition.loading"
      @click="control.entreeEdition.action"
    >
      Modifier
    </v-btn>

    <v-btn
      text
      v-if="boutonSuppressionVisible && editable"
      :loading="control.entreeSuppressionDirecte.loading"
      @click="control.entreeSuppressionDirecte.action"
    >
      Supprimer
    </v-btn>

    <v-btn
      text
      v-if="boutonModificationVisible && demandeSuppressionPossible"
      :loading="control.entreeSuppression.loading"
      @click="control.entreeSuppression.action"
    >
      Demander suppression
    </v-btn>

    <slot />

    <entiteSuppressionModal :typeObject="type" :idObject="id" />
    <entiteModificationModal />
  </v-card-actions>
</template>

<script>
export default {
  inject: ['control'],
  props: {
    demandeModication: {
      type: Boolean,
      default: true,
    },
    demandeSuppression: {
      type: Boolean,
      default: true,
    },
    enDemandeCreation: {
      type: Boolean,
      default: false,
    },
    enModeReactivation: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
    id: {
      type: Number,
    },
  },
  computed: {
    boutonSauvegardeVisible() {
      return !this.control.readonly || this.control.enDemandeSuppression;
    },
    boutonModificationVisible() {
      return (
        this.control.readonly &&
        !this.control.enDemandeSuppression &&
        !this.enModeReactivation
      );
    },
    boutonSuppressionVisible() {
      return (
        this.control.readonly &&
        !this.control.enDemandeSuppression &&
        !this.enModeReactivation &&
        (this.type === 'personne morale' ? this.demandeSuppression : true)
      );
    },
    editable() {
      return this.control.edition === 'DIRECT';
    },
    demandeModificationPossible() {
      return this.demandeModication || this.control.edition === 'DEMANDE';
    },
    demandeSuppressionPossible() {
      return this.demandeSuppression && this.boutonSuppressionVisible;
    },
  },
};
</script>
